<template>
  <div class="commonQueryIoT container">
    <div
      class="col-12 row text-left mb-2"
      v-if="selectPage == 'workorderhistory'"
    >
      <div class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">派工單號</p>
        <b-form-input
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
          v-model="singleWorkID"
        ></b-form-input>
      </div>
      <div class="mr-2" style="width: 4.25rem">
        <b-button
          class="p-0"
          @click="queryWorkIdData"
          style="
            margin-top: 38px;
            background-color: #4b8c80;
            width: 4.25rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          >查詢</b-button
        >
      </div>
    </div>
    <div class="col-12 row text-left">
      <div class="mr-2" style="" v-if="selectTag.startTime">
        <p class style="margin-bottom: 0.625rem">日期</p>
        <datepicker
          v-if="selectTag.startTime"
          :date="startTime"
          :option="startoption"
          :limit="startoption.limit"
        ></datepicker>
        <span v-if="selectTag.endTime">~</span>
        <datepicker
          v-if="selectTag.endTime"
          :date="endTime"
          :option="endoption"
          :limit="endoption.limit"
        ></datepicker>
      </div>
      <div class="mr-2" style="" v-if="selectTag.startMinTime">
        <p class style="margin-bottom: 0.625rem">時間</p>
        <input
          type="time"
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
          v-model="startMinTime"
          v-if="selectTag.startMinTime"
        />
        <span v-if="selectTag.endMinTime">~</span>
        <input
          type="time"
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
          v-model="endMinTime"
          v-if="selectTag.endMinTime"
        />
      </div>
      <!-- <div class="mx-2" style="margin-top:10px;width: 100px;">
        <p class="mb-2">廠區</p>
        <b-form-select
          style="max-width: 100px;height: 2.375rem;line-height: 1.375rem;font-size: 0.875rem;border: 2px solid rgb(255, 255, 255);box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;color: rgb(95, 95, 95);"
        ></b-form-select>
      </div>
      <div class="mx-2" style="margin-top:10px;width: 100px;">
        <p class="mb-2">組別</p>
        <b-form-select
          style="max-width: 100px;height: 2.375rem;line-height: 1.375rem;font-size: 0.875rem;border: 2px solid rgb(255, 255, 255);box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;color: rgb(95, 95, 95);"
        ></b-form-select>
      </div>
      <div
        v-if="selectPage!=='workorderhistory'"
        class="mx-2"
        style="margin-top:10px;width: 100px;"
      >
        <p class="mb-2">班別</p>
        <b-form-select
          style="max-width: 100px;height: 2.375rem;line-height: 1.375rem;font-size: 0.875rem;border: 2px solid rgb(255, 255, 255);box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;color: rgb(95, 95, 95);"
        ></b-form-select>
      </div>-->
      <div v-if="selectTag.process" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">製程</p>
        <b-form-select
          v-model="processSelected"
          :options="processOptions"
          class=""
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
        >
          <!-- This slot appears above the options from 'options' prop -->
          <template #first>
            <b-form-select-option :value="null" disabled
              >-- 選擇製程 --</b-form-select-option
            >
          </template>
        </b-form-select>
      </div>
      <div v-if="selectTag.actProcess" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">製程</p>
        <b-form-select
          v-model="actProcessSelected"
          :options="actProcessOptions"
          class=""
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
        >
          <!-- This slot appears above the options from 'options' prop -->
          <template #first>
            <b-form-select-option :value="null" disabled
              >-- 選擇製程 --</b-form-select-option
            >
          </template>
        </b-form-select>
      </div>
      <div v-if="selectTag.htProcess" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">製程</p>
        <b-form-select
          v-model="htProcessSelected"
          :options="htProcessOptions"
          class=""
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
        >
          <!-- This slot appears above the options from 'options' prop -->
          <template #first>
            <b-form-select-option :value="null" disabled
              >-- 選擇製程 --</b-form-select-option
            >
          </template>
        </b-form-select>
      </div>
      <div v-if="selectTag.inspProcess" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">製程</p>
        <b-form-select
          v-model="inspProcessSelected"
          :options="inspProcessOptions"
          class=""
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
        >
          <!-- This slot appears above the options from 'options' prop -->
          <template #first>
            <b-form-select-option :value="null" disabled
              >-- 選擇製程 --</b-form-select-option
            >
          </template>
        </b-form-select>
      </div>

      <div v-if="selectTag.group" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">組別</p>
        <b-form-select
          v-model="groupSelected"
          :options="groupOptions"
          class=""
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >-- 選擇組別 --</b-form-select-option
            >
          </template>
        </b-form-select>
      </div>
      <div v-if="selectTag.deviceCode" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">機台</p>
        <b-form-select
          v-model="deviceSelected"
          :options="deviceOptions"
          class=""
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
        >
          <!-- This slot appears above the options from 'options' prop -->
          <template #first>
            <b-form-select-option
              :value="null"
              :disabled="selectTagCheck.deviceCode"
              >-- 選擇機台 --</b-form-select-option
            >
          </template>
        </b-form-select>
        <!-- <b-form-input
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
          v-model="deviceID"
        ></b-form-input> -->
      </div>
      <div v-if="selectTag.productCode" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">產品料號</p>
        <b-form-input
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
          v-model="itemNumber"
        ></b-form-input>
      </div>
      <div v-if="selectTag.workCode" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">派工單號</p>
        <b-form-input
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
          v-model="workID"
        ></b-form-input>
      </div>
      <div v-if="selectTag.changeUserCode" class="mr-2" style="width: 9rem">
        <p class style="margin-bottom: 0.625rem">異動人員工號</p>
        <b-form-input
          style="
            max-width: 9rem;
            height: 2.375rem;
            line-height: 1.375rem;
            font-size: 0.875rem;
            border: 2px solid rgb(255, 255, 255);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
            color: rgb(95, 95, 95);
          "
          v-model="changeUserCode"
        ></b-form-input>
      </div>
      <div class="mr-2" style="width: 4.25rem">
        <b-button
          class="p-0"
          @click="queryData"
          style="
            margin-top: 38px;
            background-color: #4b8c80;
            width: 4.25rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          >查詢</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import datepicker from "vue-datepicker/vue-datepicker-es6.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "commonQueryIoT",
  data() {
    return {
      startTime: {
        time: ""
      },
      endTime: {
        time: ""
      },
      startMinTime: "",
      endMinTime: "",
      itemNumber: "",
      deviceID: "",
      processSelected: null,
      processOptions: [],
      actProcessSelected: null,
      actProcessOptions: [],
      htProcessSelected: null,
      htProcessOptions: [],
      inspProcessSelected: null,
      inspProcessOptions: [],
      deviceSelected: null,
      deviceOptions: [],
      workID: "",
      changeUserCode: "",
      singleWorkID: "",
      groupSelected: null,
      groupOptions: [],
      startoption: {
        type: "day",
        week: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
        month: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        format: "YYYY-MM-DD",
        placeholder: "",
        inputStyle: {
          display: "inline-block",
          padding: "6px",
          height: "2.375rem",
          "line-height": "2.375rem",
          "font-size": "0.875rem",
          border: "2px solid #fff",
          "box-shadow": "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
          "border-radius": "2px",
          color: "#5F5F5F",
          width: "6.5rem"
        },
        color: {
          header: "#ccc",
          headerText: "#f00"
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true, // as true as default
        limit: [
          {
            type: "fromto",
            from: "1995-01-01",
            to: "9999-01-01"
          }
        ]
      },
      endoption: {
        type: "day",
        week: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
        month: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        format: "YYYY-MM-DD",
        placeholder: "",
        inputStyle: {
          display: "inline-block",
          padding: "6px",
          height: "2.375rem",
          "line-height": "2.375rem",
          "font-size": "0.875rem",
          border: "2px solid #fff",
          "box-shadow": "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
          "border-radius": "2px",
          color: "#5F5F5F",
          width: "6.5rem"
        },
        color: {
          header: "#ccc",
          headerText: "#f00"
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true, // as true as default
        limit: [
          {
            type: "fromto",
            from: "1995-01-01",
            to: "9999-01-01"
          }
        ]
      },
      inputtext: "",
      selected: "",
      selectedCH: {
        depID: "部門編號",
        depName: "部門名稱",
        uID: "帳號",
        uName: "姓名",
        setName: "設定名稱"
      },
      settingtime: true
    };
  },
  created: function() {
    let vm = this;
    vm.dateFormat("Default");
    vm.setProcessOption();
    vm.setActProcessOption();
    vm.setHtProcessOption();
    vm.setInspProcessOption();
    if (vm.receivequeryAgain) {
      vm.queryData();
      vm.do_queryAgain();
    }
    vm.setStartTimeLimit();
  },
  mounted: function() {
    let vm = this;
    //判斷select option有無值
    //沒有值的話再Query一次
    vm.checkSelectOption();

    //判斷需要查詢包裝、出貨頁面
    vm.checkPackageOption();
  },
  components: {
    datepicker
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      queryResponse: "commonqueryiot/get_queryResponse",
      receivequeryAgain: "commonqueryiot/receive_queryAgain",
      phpfunction: "commonqueryiot/get_phpfunction",
      selectTag: "commonqueryiot/get_selectTag",
      selectTagCheck: "commonqueryiot/get_selectTagCheck",
      otherData: "commonqueryiot/get_otherData",
      plugInPage: "commonqueryiot/get_plugInPage",
      processOption: "commonqueryiot/get_processOption",
      actProcessOption: "commonqueryiot/get_actProcessOption",
      htProcessOption: "commonqueryiot/get_htProcessOption",
      inspProcessOption: "commonqueryiot/get_inspProcessOption",
      deviceOption: "commonqueryiot/get_deviceOption",
      groupOption: "commonqueryiot/get_groupOption",
      selectPage: "getlogin/get_selectPage",
      selectPageName: "getlogin/get_selectPageName",
      selectOptionQuery: "commonqueryiot/receive_selectOptionQuery",
      sideBarSelect: "sideBarTree/get_sideBarSelect"
    })
  },
  watch: {
    "startTime.time": {
      handler(value) {
        let vm = this;
        let today = new Date();
        let passYear = today.setFullYear(today.getFullYear() - 1);
        if (Date.parse(value).valueOf() < passYear) {
          let date = new Date(passYear);
          let strMonth = (date.getMonth() + 1).toString();
          let strDate = date.getDate().toString();
          value =
            date.getFullYear() +
            "-" +
            strMonth.padStart(2, "0") +
            "-" +
            strDate.padStart(2, "0");
          vm.startTime.time = value;
          vm.startTime.placeholder = value;
        }

        if (Date.parse(value).valueOf() < Date.parse("2021").valueOf()) {
          value = "2021-01-01";
          vm.startTime.time = value;
          vm.startTime.placeholder = value;
        }
        if (
          Date.parse(vm.endTime.time).valueOf() < Date.parse(value).valueOf()
        ) {
          vm.endTime.time = value;
          vm.endoption.placeholder = value;
        }

        let limitDate = new Date(value);
        limitDate = limitDate.setDate(limitDate.getDate() - 1);
        limitDate = new Date(limitDate);

        vm.endoption.limit[0].from = limitDate;
        vm.endoption.limit[0].to = "";

        if (
          vm.selectPage == "statisticstable" &&
          vm.plugInPage == "inspectTimeout"
        ) {
          let maxDate = new Date(value);
          maxDate = maxDate.setDate(maxDate.getDate() + 30);
          maxDate = new Date(maxDate);
          vm.endoption.limit[0].to = maxDate;
          if (
            Date.parse(maxDate).valueOf() <
            Date.parse(vm.endTime.time).valueOf()
          ) {
            vm.endTime.time = value;
            vm.endoption.placeholder = value;
          }
        }
      }
      // deep: true
    },
    "endTime.time": {
      handler(value) {
        let vm = this;
        if (
          Date.parse(value).valueOf() < Date.parse(vm.startTime.time).valueOf()
        ) {
          vm.endTime.time = vm.startTime.time;
          vm.endTime.placeholder = vm.startTime.placeholder;
        }
      }
      // deep: true
    },
    startMinTime: {
      handler(value) {
        let vm = this;
        let startTimeStr = vm.startTime.time + " " + vm.startMinTime;
        let endTimeStr = vm.startTime.time + " " + vm.endMinTime;

        if (
          Date.parse(startTimeStr).valueOf() > Date.parse(endTimeStr).valueOf()
        ) {
          vm.endMinTime = vm.startMinTime;
        }
      }
    },
    endMinTime: {
      handler(value) {
        let vm = this;
        let startTimeStr = vm.startTime.time + " " + vm.startMinTime;
        let endTimeStr = vm.startTime.time + " " + vm.endMinTime;

        if (
          Date.parse(startTimeStr).valueOf() > Date.parse(endTimeStr).valueOf()
        ) {
          vm.endMinTime = vm.startMinTime;
        }
      }
    },
    processOption: {
      handler() {
        this.setProcessOption();
      }
    },
    actProcessOption: {
      handler() {
        this.setActProcessOption();
      }
    },
    htProcessOption: {
      handler() {
        this.setHtProcessOption();
      }
    },
    inspProcessOption: {
      handler() {
        this.setInspProcessOption();
      }
    },
    processSelected: {
      handler(value) {
        this.setDeviceOption();
        if (value == "noProcess") {
          this.deviceSelected = null;
        }
      }
    },
    actProcessSelected: {
      handler(value) {
        this.setGroupOption();
        if (value == "noProcess") {
          this.groupSelected = null;
        }
      }
    },
    htProcessSelected: {
      handler(value) {
        let vm = this;
        vm.deviceSelected = null;
        vm.deviceOptions = vm.deviceOption[vm.htProcessSelected];
        if (value == "noProcess") {
          this.deviceSelected = null;
        }
      }
    },
    inspProcessSelected: {
      handler(value) {
        this.setGroupOption();
        if (value == "noProcess") {
          this.groupSelected = null;
        }
      }
    },
    receivequeryAgain: {
      handler() {
        let vm = this;
        if (vm.receivequeryAgain) {
          vm.queryData();
          vm.do_queryAgain();
        }
      }
    }
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      set_queryResponse: "commonqueryiot/set_queryResponse",
      set_queryProcess: "commonqueryiot/set_queryProcess",
      change_tableBusy: "commonqueryiot/change_tableBusy",
      do_queryAgain: "commonqueryiot/do_queryAgain",
      show_loadScreenModal: "loadscreenmodal/show_loadScreenModal",
      hide_loadScreenModal: "loadscreenmodal/hide_loadScreenModal",
      set_exportFileName: "exportcsv/set_exportFileName",
      set_processOption: "commonqueryiot/set_processOption",
      set_actProcessOption: "commonqueryiot/set_actProcessOption",
      set_htProcessOption: "commonqueryiot/set_htProcessOption",
      set_inspProcessOption: "commonqueryiot/set_inspProcessOption",
      set_deviceOption: "commonqueryiot/set_deviceOption",
      set_groupOption: "commonqueryiot/set_groupOption"
    }),
    setProcessOption() {
      let vm = this;
      vm.processOptions = vm.processOption;
    },
    setActProcessOption() {
      let vm = this;
      vm.actProcessOptions = vm.actProcessOption;
    },
    setHtProcessOption() {
      let vm = this;
      vm.htProcessOptions = vm.htProcessOption;
    },
    setInspProcessOption() {
      let vm = this;
      vm.inspProcessOptions = vm.inspProcessOption;
    },
    setDeviceOption() {
      let vm = this;
      vm.deviceSelected = null;
      vm.deviceOptions = vm.deviceOption[vm.processSelected];
    },
    setGroupOption() {
      let vm = this;
      vm.groupSelected = null;
      if (vm.selectTag.actProcess) {
        vm.groupOptions = vm.groupOption[vm.actProcessSelected];
      } else if (vm.selectTag.inspProcess) {
        vm.groupOptions = vm.groupOption[vm.inspProcessSelected];
      }
    },
    //查詢API
    queryDataFunction() {
      let vm = this;
      var params = {};
      var startTime = vm.startTime.time;
      var endTime = vm.endTime.time;
      let startMinTime = vm.startMinTime;
      let endMinTime = vm.endMinTime;
      let itemNumber = vm.itemNumber;
      let process = vm.processSelected;
      let actProcess = vm.actProcessSelected;
      let htProcess = vm.htProcessSelected;
      let inspProcess = vm.inspProcessSelected;
      let deviceID = vm.deviceSelected;
      let workID = vm.workID;
      let changeUserCode = vm.changeUserCode;
      let group = vm.groupSelected;

      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["whichFunction"] = vm.phpfunction;
      params["otherData"] = vm.otherData;
      // startTime != "" ? (params["startTime"] = startTime + " 00:00:00") : "";
      endTime != "" ? (params["endTime"] = endTime + " 23:59:59") : "";
      itemNumber != "" ? (params["itemNumber"] = itemNumber) : "";
      process != "" ? (params["process"] = process) : "";
      actProcess != "" ? (params["actProcess"] = actProcess) : "";
      htProcess != "" ? (params["htProcess"] = htProcess) : "";
      inspProcess != "" ? (params["inspProcess"] = inspProcess) : "";
      deviceID != "" ? (params["deviceID"] = deviceID) : "";
      workID != "" ? (params["workID"] = workID) : "";
      changeUserCode != "" ? (params["changeUserCode"] = changeUserCode) : "";
      group != "" ? (params["group"] = group) : "";
      //預設今天
      params["startTime"] = startTime + " 00:00:00";
      // params["endTime"] = endTime + " 23:59:59";
      params["startMinTime"] = startMinTime;
      params["endMinTime"] = endMinTime;
      console.log(params);
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result);
        vm.change_tableBusy();
        if (result["Response"] == "ok") {
          if (
            result.hasOwnProperty("QueryPage") &&
            result["QueryPage"] == "wireinquire"
          ) {
            result["QueryTableData"] = result["QueryTableData"].sort(function(
              a,
              b
            ) {
              return a.itme_index - b.itme_index;
            });
          } else if (
            result.hasOwnProperty("QueryPage") &&
            (result["QueryPage"] == "statisticstable" ||
              result["QueryPage"] == "maintainlog")
          ) {
          } else {
            result["QueryTableData"] = result["QueryTableData"].sort(function(
              a,
              b
            ) {
              return a.lastUpdateTime < b.lastUpdateTime ? 1 : -1;
            });
          }

          if (
            result.hasOwnProperty("Process") &&
            result["Process"] == "package"
          ) {
            vm.set_queryProcess("package");
          } else if (
            result.hasOwnProperty("Process") &&
            result["Process"] == "container"
          ) {
            vm.set_queryProcess("container");
          } else {
            vm.set_queryProcess(null);
          }

          vm.set_queryResponse(result["QueryTableData"]);
          let exportFileName =
            vm.selectPageName +
            "_" +
            (deviceID != "" ? deviceID : "ALL") +
            "_" +
            new Date().getFullYear() +
            ("0" + (new Date().getMonth() + 1)).slice(-2) +
            ("0" + new Date().getDate()).slice(-2);
          vm.set_exportFileName(exportFileName);
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
          vm.set_queryResponse("查無資料");
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
          vm.set_queryResponse(result["Response"]);
        }
      });
    },
    //時間格式化
    dateFormat(Default) {
      let vm = this;
      var now = new Date();
      if (Default === "Default") {
        var todayDate_start =
          now.getFullYear() +
          "-" +
          ("0" + (now.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + now.getDate()).slice(-2);
        var todayDate_end =
          now.getFullYear() +
          "-" +
          ("0" + (now.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + now.getDate()).slice(-2);
        vm.startoption.placeholder = todayDate_start;
        vm.startTime.time = todayDate_start;
        vm.endoption.placeholder = todayDate_end;
        vm.endTime.time = todayDate_end;
      } else {
        vm.reset([
          "startTime",
          "endTime",
          "startMinTime",
          "endMinTime",
          "selected",
          "inputtext",
          "settingtime",
          "itemNumber",
          "deviceID",
          "workID",
          "changeUserCode",
          "processSelected",
          "processOptions",
          "actProcessSelected",
          "actProcessOptions",
          "inspProcessSelected",
          "inspProcessOptions",
          "deviceSelected",
          "deviceOptions",
          "groupSelected",
          "groupOptions",
          "htProcessSelected",
          "htProcessOptions"
        ]);
        vm.change_tableBusy();
        vm.queryDataFunction();
      }
    },
    //查詢按鈕
    queryData() {
      let vm = this;
      vm.show_loadScreenModal();
      if (!vm.settingtime) {
        if (vm.startTime.time == "" || vm.endTime.time == "") {
          if (vm.queryResponse == "時間尚未選擇") {
            vm.set_alertMsg("時間尚未選擇");
            vm.settimeout_alertModal();
          }
          vm.set_queryResponse("時間尚未選擇");
          vm.hide_loadScreenModal();
          return;
        }
      }
      let selectTagKey = Object.keys(vm.selectTag);
      let selectTagCheckKey = Object.keys(vm.selectTagCheck);
      let tag = {
        startMinTime: {
          value: "startMinTime",
          text: "請選擇開始時間",
          check: true
        },
        endMinTime: {
          value: "endMinTime",
          text: "請選擇結束時間",
          check: true
        },
        process: {
          value: "processSelected",
          text: "請選擇製程",
          check: true
        },
        actProcess: {
          value: "actProcessSelected",
          text: "請選擇製程",
          check: true
        },
        htProcess: {
          value: "htProcessSelected",
          text: "請選擇製程",
          check: true
        },
        inspProcess: {
          value: "inspProcessSelected",
          text: "請選擇製程",
          check: true
        },
        deviceCode: {
          value: "deviceSelected",
          text: "請選擇機台",
          check: true
        },
        productCode: { value: "itemNumber", text: "", check: false },
        workCode: { value: "workID", text: "請輸入派工單號", check: false },
        changeUserCode: {
          value: "changeUserCode",
          text: "請輸入異動人員工號",
          check: false
        },
        group: { value: "groupSelected", text: "請選擇組別", check: true }
      };

      selectTagCheckKey.forEach(item => {
        if (tag[item]) {
          tag[item]["check"] = vm.selectTagCheck[item];
        }
      });
      for (let i = 0; i < selectTagKey.length; i++) {
        if (selectTagKey[i] != "startTime" && selectTagKey[i] != "endTime") {
          if (vm.selectTag[selectTagKey[i]]) {
            if (tag[selectTagKey[i]].check) {
              if (
                vm[tag[selectTagKey[i]].value] == "" ||
                vm[tag[selectTagKey[i]].value] == null ||
                vm[tag[selectTagKey[i]].value] == undefined
              ) {
                if (vm.actProcessSelected == 8) {
                  if (tag[selectTagKey[i]].value != "groupSelected") {
                    vm.set_alertMsg(tag[selectTagKey[i]].text);
                    vm.settimeout_alertModal();
                    vm.hide_loadScreenModal();
                    return;
                  }
                } else {
                  vm.set_alertMsg(tag[selectTagKey[i]].text);
                  vm.settimeout_alertModal();
                  vm.hide_loadScreenModal();
                  return;
                }
              }
            }
          }
        }
      }

      vm.dateFormat(vm.selected);
    },
    //工單單獨查詢按鈕
    queryWorkIdData() {
      let vm = this;
      vm.show_loadScreenModal();
      if (vm.singleWorkID == "") {
        vm.set_alertMsg("請輸入派工單號");
        vm.settimeout_alertModal();
        vm.hide_loadScreenModal();
        return;
      }
      vm.queryWorkIdFunction();
    },
    //工單單獨查詢API
    queryWorkIdFunction() {
      let vm = this;
      let params = {};
      let workID = vm.singleWorkID;
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["whichFunction"] = vm.phpfunction;
      params["otherData"] = vm.otherData;
      params["workID"] = workID;
      params["singleWorkIdQuery"] = true;

      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result);
        vm.change_tableBusy();
        if (result["Response"] == "ok") {
          if (
            result.hasOwnProperty("QueryPage") &&
            result["QueryPage"] == "wireinquire"
          ) {
            result["QueryTableData"] = result["QueryTableData"].sort(function(
              a,
              b
            ) {
              return a.itme_index - b.itme_index;
            });
          } else if (
            result.hasOwnProperty("QueryPage") &&
            result["QueryPage"] == "statisticstable"
          ) {
          } else {
            result["QueryTableData"] = result["QueryTableData"].sort(function(
              a,
              b
            ) {
              return a.lastUpdateTime < b.lastUpdateTime ? 1 : -1;
            });
          }

          if (
            result.hasOwnProperty("Process") &&
            result["Process"] == "package"
          ) {
            vm.set_queryProcess("package");
          } else if (
            result.hasOwnProperty("Process") &&
            result["Process"] == "container"
          ) {
            vm.set_queryProcess("container");
          } else {
            vm.set_queryProcess(null);
          }

          vm.set_queryResponse(result["QueryTableData"]);
          let exportFileName =
            vm.selectPageName +
            "_" +
            (workID != "" ? workID : "ALL") +
            "_" +
            new Date().getFullYear() +
            ("0" + (new Date().getMonth() + 1)).slice(-2) +
            ("0" + new Date().getDate()).slice(-2);
          vm.set_exportFileName(exportFileName);
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
          vm.set_queryResponse("查無資料");
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
          vm.set_queryResponse(result["Response"]);
        }
      });
    },
    setStartTimeLimit() {
      //設置查詢起始日限制(從今天往前推算一年)
      let vm = this;
      let limitDate = new Date();
      limitDate = limitDate.setFullYear(limitDate.getFullYear() - 1);
      limitDate = new Date(limitDate);
      vm.startoption.limit[0].from = limitDate;
      vm.startoption.limit[0].to = "9999-01-01";
    },
    getSelectOption() {
      let vm = this;
      var params = {};
      params["vuePage"] = "selectoption";
      params["methods"] = "GET";
      params["whichFunction"] = "SelectOption";
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          if (vm.selectPage == "workorderhistory") {
            //工單履歷加入包裝、出貨選項
            result.QueryTableData.process.push({
              value: "package-8",
              text: "包裝"
            });
            result.QueryTableData.process.push({
              value: "container-9",
              text: "出貨"
            });
            result.QueryTableData.device["package-8"] = [
              {
                value: "1",
                text: "01"
              },
              {
                value: "2",
                text: "02"
              },
              {
                value: "3",
                text: "03"
              },
              {
                value: "4",
                text: "04"
              },
              {
                value: "5",
                text: "05"
              },
              {
                value: "6",
                text: "06"
              },
              {
                value: "7",
                text: "07"
              },
              {
                value: "8",
                text: "08"
              },
              {
                value: "9",
                text: "09"
              },
              {
                value: "10",
                text: "10"
              },
              {
                value: "11",
                text: "11"
              },
              {
                value: "12",
                text: "12"
              }
            ];

            result.QueryTableData.device["container-9"] = [
              {
                value: "A1",
                text: "A1"
              },
              {
                value: "A2",
                text: "A2"
              },
              {
                value: "A3",
                text: "A3"
              }
            ];
          }
          vm.set_processOption(result.QueryTableData.process);
          vm.set_actProcessOption(result.QueryTableData.actProcess);
          vm.set_htProcessOption(result.QueryTableData.htProcess);
          vm.set_inspProcessOption(result.QueryTableData.inspProcess);
          vm.set_groupOption(result.QueryTableData.group);
          vm.set_deviceOption(result.QueryTableData.device);
        }
      });
    },
    checkSelectOption() {
      //判斷select option有無值
      //沒有值的話再Query一次
      let vm = this;
      if (vm.selectOptionQuery === false) {
        if (
          vm.processOption.length == 0 ||
          vm.actProcessOption.length == 0 ||
          vm.inspProcessOption.length == 0 ||
          Object.keys(vm.deviceOption).length == 0 ||
          Object.keys(vm.groupOption).length == 0
        ) {
          vm.getSelectOption();
        }
      }
    },
    checkPackageOption() {
      let vm = this;
      if (vm.selectOptionQuery) {
        return;
      }
      if (vm.selectPage == "workorderhistory") {
        //工單履歷加入包裝、出貨選項
        let packageSetup = false;
        let containerSetup = false;
        vm.processOption.forEach(element => {
          if (element.value == "package-8") {
            packageSetup = true;
          }
          if (element.value == "container-9") {
            containerSetup = true;
          }
        });
        if (!packageSetup) {
          vm.processOption.push({
            value: "package-8",
            text: "包裝"
          });
        }
        if (!containerSetup) {
          vm.processOption.push({
            value: "container-9",
            text: "出貨"
          });
        }

        vm.deviceOption["package-8"] = [
          {
            value: "1",
            text: "01"
          },
          {
            value: "2",
            text: "02"
          },
          {
            value: "3",
            text: "03"
          },
          {
            value: "4",
            text: "04"
          },
          {
            value: "5",
            text: "05"
          },
          {
            value: "6",
            text: "06"
          },
          {
            value: "7",
            text: "07"
          },
          {
            value: "8",
            text: "08"
          },
          {
            value: "9",
            text: "09"
          },
          {
            value: "10",
            text: "10"
          },
          {
            value: "11",
            text: "11"
          },
          {
            value: "12",
            text: "12"
          }
        ];

        vm.deviceOption["container-9"] = [
          {
            value: "A1",
            text: "A1"
          },
          {
            value: "A2",
            text: "A2"
          },
          {
            value: "A3",
            text: "A3"
          }
        ];
        // } else if (
        //   vm.selectPage == "activation" &&
        //   vm.sideBarSelect.processName == "稼動率日誌"
        // ) {
        //   // vm.actProcessOption.push({
        //   //   value: 8,
        //   //   text: "包裝",
        //   // });
      } else {
        let oriProcessOption = [];
        vm.processOption.forEach(item => {
          if (item.text === "包裝" || item.text === "出貨") {
          } else {
            oriProcessOption.push(item);
          }
        });
        vm.set_processOption(oriProcessOption);
      }
    },
    //data reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/commonQueryIoT.vue